var $bfc660c20d3b18e5$exports = {};
(function(html) {
    const YEARS_IN_MS = 31536000000;
    const start = new Date('2008-04');
    const diffYears = (Date.now() - start) / YEARS_IN_MS;
    const treeWalker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    while(treeWalker.nextNode()){
        const node = treeWalker.currentNode;
        if (node.nodeType === 3 && node.nodeValue.indexOf('{{years}}') !== -1) node.nodeValue = node.nodeValue.replace('{{years}}', Math.ceil(diffYears));
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Mozilla+Headline:wdth,wght@75,600&display=swap';
    document.head.append(link);
    function onLoad() {
        html.classList.add('loaded');
    }
    if (document.readyState === "complete") onLoad();
    else window.addEventListener('load', onLoad, false);
})(document.documentElement);


//# sourceMappingURL=build.9b20a7d3.js.map
